import { render } from "./TableCustomersDashboard.vue?vue&type=template&id=8245823a"
import script from "./TableCustomersDashboard.vue?vue&type=script&lang=js"
export * from "./TableCustomersDashboard.vue?vue&type=script&lang=js"

import "./TableCustomersDashboard.vue?vue&type=style&index=0&id=8245823a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__